import {
  useIsAdmin,
  useIsProjectLeader,
  useIsProjectRequestor,
} from "@/helpers/permissions";
import { useGetProjectQuery } from "@/services";
import { Switch } from "antd";
import { bool, object } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { DynamicFormItem } from "./DynamicFormItem";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";
import { SwitchPanel, SwitchText } from "./styled";

export const DynamicSwitch = ({
  formField,
  formField: {
    property,
    property: { label, name },
  },
  formDisabled,
}) => {
  const intl = useIntl();
  const isAdmin = useIsAdmin();
  const { projectId } = useParams();
  const { data: project, isFetching } = useGetProjectQuery(projectId, {
    skip: !projectId,
  });
  const isProjectLeader = useIsProjectLeader(isFetching, project);
  const isProjectRequestor = useIsProjectRequestor(project?.requestor);
  const { isDisabled } = useCheckEditableFormField(formField);
  const [canEditSecureFlag, setCanEditSecureFlag] = useState(false);

  useEffect(() => {
    if (name === "secureProject" && project?.requestor) {
      if (isAdmin || isProjectLeader || isProjectRequestor) {
        setCanEditSecureFlag(true);
      } else {
        setCanEditSecureFlag(false);
      }
    } else {
      setCanEditSecureFlag(true);
    }
  }, [project, name, isAdmin, isProjectLeader]);

  return (
    <SwitchPanel>
      <DynamicFormItem formFieldProperty={property} noStyle>
        <SwitchText>
          {intl.formatMessage({
            id: label.id,
            defaultMessage: label.fallback,
          })}
        </SwitchText>
      </DynamicFormItem>
      <DynamicFormItem
        formFieldProperty={property}
        noStyle={true}
        valuePropName="checked"
      >
        <Switch
          data-test-id={`dynamic-switch-${name}`}
          disabled={formDisabled || isDisabled || !canEditSecureFlag}
        />
      </DynamicFormItem>
    </SwitchPanel>
  );
};

DynamicSwitch.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
